import { Box, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useOptionSelectedEditStyles } from "./optionSelectedEditStyles"
import { DynamicFormRef } from "../../../../../../../../../../components/dynamicFormRef"
import { DinamicFormRefModel, DynamicRefRef } from "../../../../../../../../../../components/dynamicFormRef/types"
import { useReportFoliosDetailContext } from "../../../../hooks/useReportFoliosContext"
import { useLayoutEffect } from "react"
import { useRefs } from "../../../../../../../../../../hooks/useReactHookModified"
import { Item } from "../../../../../../../../../../utils/types/generals"
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService"
import { useParams } from "react-router-dom"
import { handleAllErrors } from "../../../../../../../../../../utils/methods/handleErrors"
import { Types } from "../../../../../../../../../../utils/enums"
import { LoadingButton } from "@mui/lab"

const DetailOption = ({ refresh }: { refresh: () => void }) => {
    const { addRef, refsByKey } = useRefs<DynamicRefRef>()
    const { t } = useTranslation()
    const { id } = useParams()
    const { callEditEndpoint, items, setSnackbar, setLoadings, loadings, selectOption, setModal, closeModal } = useReportFoliosDetailContext()
    const styles = useOptionSelectedEditStyles()
    const modelEdit: Record<string, DinamicFormRefModel | null> = {
        unit: {
            id: 'unit',
            label: t('general.tags.unit'),
            name: 'unit',
            type: 'selectSimple',
            items: items.units,
            validations: {
                required: { value: true }
            }
        },
        area: {
            id: 'area',
            label: t('general.tags.area'),
            name: 'area',
            type: 'selectSimple',
            items: items.area,
            selectOptions: {
                child: {
                    childKey: 'department',
                    parentId: 'areaId'
                }
            },
            validations: {
                required: { value: true }
            }
        },
        department: {
            id: 'department',
            label: t('general.tags.department'),
            name: 'department',
            type: 'selectSimple',
            items: items.department,
            selectOptions: {
                parent: {
                    parentKey: "area",
                    parentId: "areaId",
                }
            },
            validations: {
                required: { value: true }
            }
        },
        reason: {
            id: 'reason',
            label: t('general.tags.reason'),
            name: 'reason',
            type: 'text',
            rows: 3,
            maxRows: 3,
            multiline: true,
            validations: {
                required: { value: true },
                min: {value: 3},
            },
            wrapper: ({ children, id }) => {
                return (
                    <Box key={id}>
                        <Typography sx={[styles.reasonTitle, styles['mb-10']]}>{t('reportFolio.detail.editReportFolio.describeAReason')}</Typography>

                        {children}
                    </Box>
                )
            }
        },
    }

    const getData = async () => {
        setLoadings(prev => ({ ...prev, update: true, next: true }))
        const ref = refsByKey['edit']
        if (ref?.getValues) {
            const data = ref?.getValues()

            const body = {
                "description": data?.reason,
                "storeId": (data?.unit as Item)?.value,
                "areaId": (data?.area as Item)?.value,
                "departmentId": (data?.department as Item)?.value
            }

            const response = await reportFolioServices.editFolio({ body, id: id ?? "" })
            const code = response?.errors?.[0]?.code

            if (code) {
                setSnackbar({
                    open: true,
                    message: handleAllErrors(code, t, ''),
                    type: Types.ERROR
                })
            } else {
                setSnackbar({
                    open: true,
                    message: t('reportFolio.detail.editReportFolio.message.edit'),
                    type: Types.SUCCESS
                })
                selectOption(null)
                refresh()
                closeModal()
            }

        }

        setLoadings(prev => ({ ...prev, update: false, next: false }))
    }

    const confirmUpdate = () => {
        const ref = refsByKey['edit']
        const isValid = ref?.validate()
        if (!isValid) {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('reportFolio.detail.general.editFolio'),
                description: t(''),
                confirm: () => {
                    getData()
                },
                cancel: () => {
                    closeModal()
                }
            }))
        }
    }
    useLayoutEffect(() => {
        callEditEndpoint()
    }, [])

    return (
        <Box sx={styles.container}>
            <Typography sx={[styles.reasonTitle, styles.title]}>{t('reportFolio.detail.editReportFolio.title')}</Typography>

            <DynamicFormRef
                ref={(element) => addRef({ element, name: 'edit' })}
                model={modelEdit}
                styleSx={{width: '80%'}}
                parentWrapper={({ children }) => {
                    return (
                        <Box sx={styles.parentContainer}>
                            {children}
                        </Box>
                    )
                }}
            />

            <LoadingButton loading={loadings.update} sx={styles.btnBlue} variant="contained" onClick={confirmUpdate}>{t('general.update')}</LoadingButton>
        </Box>
    )
}

export { DetailOption }